export default __webpack_public_path__ + "static/home_page_measurement-de120a6c0e78b8bcbfbfad8fdaa9a516.webm";